<template>
  <v-select
    :items="items"
    v-model="value"
    :label="label"
    filled
  ></v-select>
</template>

<script>
import basicModel from '@codehq/aurora-app-core/src/mixins/basicModel';

export default {
  name: 'SelectGutsRemoved',
  props: ['label'],
  mixins: [basicModel],
  data() {
    return {
      items: ['Good', 'Bad', 'Acceptable'],
    };
  },
};
</script>
